import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { useParams } from "react-router-dom";
import PdfViewer from "../../components/legal/PdfViewer";
import LegalSearchBox from "../../components/legal/LegalSearchBox";
import AskSocietyExpert from "../../components/legal/AskSocietyExpert";

export default function LegalDocViewer() {
  const { docId } = useParams();
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [searching, setSearching] = useState(false);
  const [results, setResults] = useState([]);

  useEffect(() => {
    (async () => {
      const snap = await getDoc(doc(db, "legal_docs", docId));
      if (snap.exists()) setMeta({ id: snap.id, ...snap.data() });
    })();
  }, [docId]);

  const runSearch = async (q) => {
    setSearching(true);
    setResults([]);
    try {
      const r = await fetch(`${process.env.REACT_APP_FUNCTIONS_API}/legal/search`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ docId, query: q }),
      });
      const j = await r.json();
      setResults(j.results || []);
    } finally {
      setSearching(false);
    }
  };

  if (!meta) return <div className="min-h-screen bg-slate-100 p-6">Loading…</div>;

  return (
    <div className="min-h-screen bg-slate-100">
      <div className="max-w-7xl mx-auto px-4 py-6 space-y-4">
        <div className="bg-white rounded-2xl border shadow-sm p-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div>
            <div className="text-xs font-bold text-slate-500">{meta.type} • {meta.language} • {meta.year || "-"}</div>
            <div className="text-xl font-extrabold text-slate-900">{meta.title}</div>
          </div>
          <a
            href={meta.pdfUrl}
            target="_blank"
            rel="noreferrer"
            className="px-4 py-2 rounded-xl bg-emerald-600 text-white font-semibold text-sm text-center"
          >
            ⬇ Download PDF
          </a>
        </div>

        <div className="grid lg:grid-cols-12 gap-4">
          <div className="lg:col-span-8 space-y-3">
            <LegalSearchBox onSearch={runSearch} loading={searching} />

            {results?.length ? (
              <div className="bg-white rounded-2xl border shadow-sm p-3">
                <div className="text-xs font-extrabold text-slate-700 mb-2">Search Results</div>
                <div className="space-y-2">
                  {results.map((r, i) => (
                    <button
                      key={i}
                      onClick={() => setPage(r.pageNo || 1)}
                      className="w-full text-left p-3 rounded-xl border hover:bg-slate-50"
                    >
                      <div className="text-xs font-bold text-slate-600">Page {r.pageNo}</div>
                      <div className="text-sm text-slate-800">{r.snippet}</div>
                    </button>
                  ))}
                </div>
              </div>
            ) : null}

            <PdfViewer url={meta.pdfUrl} initialPage={page} onPageCount={() => {}} />
          </div>

          <div className="lg:col-span-4 space-y-3">
            <AskSocietyExpert docId={docId} onOpenPage={(p) => setPage(p)} />

            <div className="bg-white rounded-2xl border shadow-sm p-4 text-sm text-slate-700">
              <div className="font-extrabold mb-1">✅ How to use</div>
              <ul className="list-disc ml-5 space-y-1">
                <li>Search keyword se relevant pages niklenge.</li>
                <li>Ask Society Expert se answer + page references milenge.</li>
                <li>Reference chips pe tap karke PDF wahi page pe open hoga.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
